import { createRelayEnvironment } from './createRelayEnvironment';

export const AtlassianRelayEnvironment = createRelayEnvironment({});
